import { Company } from './../../domain/model/company';
import { AxiosResponse, AxiosInstance, AxiosError } from 'axios';
import Handler from '@/core/domain/usecase/handler';

export interface DeleteCompanyRepository {
    (id: number): Promise<Company>
}

const deleteCompanyRepository = (axios: AxiosInstance): DeleteCompanyRepository => async (id: number) => {
    try {
        const response: AxiosResponse = await axios.delete(`/company/${id}`)

        const company: Company = response.data
        return company
    } catch (err: any | AxiosError) {
        if (err.isAxiosError) {
            throw new Handler().trataErro(err)
        } else {
            throw err
        }
    }
}

export default deleteCompanyRepository